// Plotly's Browserify/d3 v3 bundle needs sloppy-mode `this`, so load it as a classic script.
export default window.Plotly;
